
<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper" v-if="!taskId">
        <a-form  @keyup.enter.native="searchQuery" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" name="basic">
          <a-row :gutter="24">
            <a-col :span="4">
              <a-form-item label="题库">
                <j-dict-select-tag placeholder="请选择题库" 
                 :trigger-change="true"
                 @change="questionLibraryChange"
                 v-model="queryParam.questionLibrary"
                 :defaultShowAll="true"
                 dictCode="question_library" />
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="状态">
                <j-dict-select-tag placeholder="请选择状态" v-model="queryParam.questionStatus" dictCode="question_status" />
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="题型">
                <j-dict-select-tag placeholder="请选择题型" v-model="queryParam.questionType" dictCode="question_type" />
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="难度">
                <j-dict-select-tag placeholder="请选择难度" v-model="queryParam.questionDifficulty" dictCode="question_difficulty" />
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="ID">
                <a-input placeholder="请输入题目ID" v-model="queryParam.id"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="题目名">
                <a-input placeholder="请输入题目名" v-model="queryParam.questionName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="题干">
                <a-input placeholder="请输入题干关键词" v-model="queryParam.questionStem"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px" v-if="type == 2">新增</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
      <div>
        <a-table ref="table" size="middle" bordered rowKey="id" class="j-table-force-nowrap" :scroll="{ x: true }"
          :columns="columns" :dataSource="dataSource" :pagination="ipagination" :loading="loading"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" @change="handleTableChange">
  
          <template slot="htmlSlot" slot-scope="text">
            <a-popover title="题干预览" placement="right">
              <div slot="content" v-html="text"></div>
              <a-icon type="eye" theme="twoTone" />
            </a-popover>
          </template>
          <template slot="imgSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
            <img v-else :src="getImgView(text)" :preview="text" height="25px" alt=""
              style="max-width:80px;font-size: 12px;font-style: italic;" />
          </template>
          <template slot="fileSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
            <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
              下载
            </a-button>
          </template>
           <!-- 字符串超长截取省略号显示-->
          <span slot="dataContent" slot-scope="text, record">
            <j-ellipsis :value="text" :length="30" />
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="handleDetail(record)">详情</a>
            <a-divider  type="vertical" v-if="type == 2" />
            <a  @click="handleEdit(record, 0)" v-if="type == 2">编辑</a>
            <!-- <a-divider v-has="'question:review'" type="vertical" />
            <a v-has="'question:review'" @click="handleEdit(record, 0)">审核</a> -->
            <a-divider type="vertical" v-if="type == 2" />
            <a-dropdown  v-if="type == 2">
              <a class="ant-dropdown-link">更多
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item >
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                    <a>删除</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
  
        </a-table>
      </div>
      <teaching-question-modal ref="modalForm" @ok="modalFormOk" />
    </a-card>
  </template>
  
  <script>
  
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TeachingQuestionModal from './components/testPaper/TeachingQuestionModal'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import { loadCategoryData } from '@/api/api'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import JCategorySelect from '@comp/jeecg/JCategorySelect'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import JEllipsis from "@/components/jeecg/JEllipsis";
  import '@/assets/less/TableExpand.less'
  
  export default {
    name: "TeachingQuestionList",
    mixins: [JeecgListMixin],
    components: {
      JDictSelectTag,
      JCategorySelect,
      JSearchSelectTag,
      TeachingQuestionModal,
      JEllipsis
    },
    props:{
      taskId:{
        type: String
      }
    },
    data() {
      return {
        description: '题库管理页面',
        //列设置
        settingColumns:[],
        //表头
        columns:[],
        // 列定义
        defColumns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '题目ID',
            align: "center",
            dataIndex: 'id',
          },
          {
            title: '题型',
            align: "center",
            width: 100,
            sorter: true,
            dataIndex: 'questionType_dictText'
          },
          {
            title: '题目名',
            align: "center",
            sorter: true,
            dataIndex: 'questionName',
          },
          {
            title: '所属题库',
            align: "center",
            width: 80,
            dataIndex: 'questionLibrary_dictText',
            sorter: true,
          },
          {
            title: '所属命题任务',
            align: "center",
            width: 180,
            dataIndex: 'taskId_dictText',
            sorter: true,
          },
          {
            title: '状态',
            align: "center",
            width: 80,
            dataIndex: 'questionStatus_dictText',
            sorter: true,
          },
          {
            title: '知识点',
            align: "center",
            dataIndex: 'knowledgePoint',
            width: 250,
            scopedSlots: {customRender: 'dataContent'},
            customRender: (text) => (text ? filterMultiDictText(this.dictOptions['knowledgePoint'], text, true) : '')
          },
          {
            title: '题目标签',
            align: "center",
            dataIndex: 'tag',
            width: 250,
            scopedSlots: {customRender: 'dataContent'},
            customRender: (text) => (text ? filterMultiDictText(this.dictOptions['tag'], text, true) : '')
          },
          {
            title: '题干',
            align: "center",
            dataIndex: 'questionStem',
            width: 70,
            scopedSlots: { customRender: 'htmlSlot' }
          },
          {
            title: '难度',
            align: "center",
            width: 70,
            sorter: true,
            dataIndex: 'questionDifficulty_dictText'
          },
          {
            title: '参考分',
            align: 'center',
            width: 70,
            sorter: true,
            dataIndex: 'questionScore'
          },
          // {
          //   title: '关联课程单元',
          //   align: "center",
          //   width: 200,
          //   dataIndex: 'unitId_dictText'
          // },
          {
            title: '绑定试卷',
            align: 'center',
            width: 200,
            dataIndex: 'bindPaperIds_dictText',
            scopedSlots: {customRender: 'dataContent'},
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/teaching/teachingQuestion/list",
          delete: "/teaching/teachingQuestion/delete",
          deleteBatch: "/teaching/teachingQuestion/deleteBatch",
          exportXlsUrl: "/teaching/teachingQuestion/exportXls",
          importExcelUrl: "teaching/teachingQuestion/importExcel",
  
        },
        dictOptions: {},
        disableMixinCreated: true,
        queryParam: {
          questionLibrary: ''
        },
        taskInfo: null
      }
    },
    watch: {
      taskId(v){
        console.log(v);
        if(v){
          this.queryParam.taskId = v
          this.searchQuery()
        }
      }
    },
    created() {
      if(this.taskId){
        this.queryParam.taskId = this.taskId
      }
      this.initColumns()
      this.initDictConfig()
      this.searchQuery()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      type(){
        return this.$route.query.type
      }
    },
    methods: {
      filterMultiDictText,
      handleAdd() {
        this.$refs.modalForm.title = "新增";
        this.$refs.modalForm.disableSubmit = false;
        this.$refs.modalForm.add(this.taskInfo);
      },
      handleEdit(record, editType){
        this.$refs.modalForm.edit(record, editType, this.taskInfo);
        if(editType == 1){
          this.$refs.modalForm.title = "审核";
        }else{
          this.$refs.modalForm.title = "编辑";
        }
        this.$refs.modalForm.disableSubmit = false;
      },
      initDictConfig() {
        loadCategoryData({ code: "A04" }).then((res) => {
          if (res.success) {
            this.$set(this.dictOptions, 'tag', res.result)
          }
        })
        loadCategoryData({ code: "A07" }).then((res) => {
          if (res.success) {
            this.$set(this.dictOptions, 'knowledgePoint', res.result)
          }
        })
      },
      //打开字典编辑器
      handleEditDict(dictCode) {
        this.$refs.dictItemList.open(dictCode)
      },
      //打开分类字典编辑器
      handleEditCateDict(dictCode){
        this.$refs.categoryDrawer.open(dictCode)
      },
      searchQuery() {
        let stem = this.queryParam.questionStem
        if (stem) {this.queryParam.questionStem = "*" + stem + "*"}
        this.loadData(1);
        this.queryParam.questionStem = stem
      },
      questionLibraryChange(v) {
        console.log(v);
        this.queryParam.questionLibrary = v
        this.searchQuery()
      },
      path2type(routePath) {
        console.log(routePath);
        let keys = routePath.split("/")
        console.log(keys);
        if(keys.length == 4){
          return parseInt(keys[keys.length-1])
        }
        return undefined
      },
      getQuestionDifficulty(v){
        switch (v) {
          case 1: return "易"
          case 2: return "中"
          case 3: return "难"
          default: return v
        } 
      },
      hideQuestionList(){
        this.$emit("hide")
      }
    }
  }
  </script>
  <style scoped>
  @import '~@assets/less/common.less';
  </style>